<template>
  <div v-if="url" class="link-wrapper">
    <a class="link uk-button uk-button-primary uk-display-inline-block" :href="url" target="_blank" v-wave>
      <div class="uk-flex uk-flex-middle uk-flex-center">
        <span>{{ label }}</span>
        <i class="material-symbols-sharp" data-icon="open_in_new"></i>
      </div>
    </a>
  </div>
</template>

<script lang="ts" setup>
defineProps<{url: string, label: string }>()
</script>

<style lang="scss" scoped>
.link {
  color: var(--text-color);
  border-radius: 10rem;
  span {
    opacity: 0.8;
    font-size: 1rem;
    padding: 1rem 0;
    line-height: 1rem;
  }
  i {
    opacity: 0.8;
    padding: 0.125rem 0 0 0.5rem;
  }
  &:hover {
    i, span {
      opacity: 1;
    }
  }
}
</style>
